import React, { useState, useEffect, useCallback } from "react";
import founderImage from "../../assets/NewfounderImg.png";
import heroBg from "../../assets/hero-bg.png"; // Ensure this matches your file name
import sustainabilityBg from "../../assets/sustainability-bg.jpg"; // Ensure this matches your file name
import "./AboutUsComponent.css";

const AboutUsPage = () => {
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);

  const heroTitles = [
    "Sustainability",
    "Best Practices",
    "Industry Growth",
    "AI Impact",
    "Diversity",
    "100+ Participants",
    "Facility Management",
    "Corporate Real Estate",
    "Architects",
    "Developers",
    "Workplace Strategists",
    "Founders",
    "CXOs",
    "Startup Leaders",
    "4 Cities",
    "14+ Platforms",
    "Real Estate Startups",
  ];

  const nextTitle = useCallback(() => {
    setCurrentTitleIndex((prevIndex) => (prevIndex + 1) % heroTitles.length);
  }, [heroTitles.length]);

  useEffect(() => {
    const titleInterval = setInterval(() => {
      nextTitle();
    }, 2000);

    return () => clearInterval(titleInterval);
  }, [nextTitle]);
  return (
    <div className="about-page">
      {/* 1. New Hero Section */}
      <div className="about-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-content">
          <h1 className="about-title">About us</h1>
        </div>
      </div>

      <div className="about-main-wrapper">
        {/* 2. Founder's Message Section */}
        <section className="founder-section">
          <h2 className="section-header">Founder’s Message</h2>
          <div className="founder-content">
            <div className="founder-image-wrapper">
              {/* Ensure this image path is correct */}
              <img
                src={founderImage}
                alt="Sunanda Jaiprakash"
                className="founder-img"
              />
            </div>
            <div className="founder-text-block">
              <p>
                At CREDTECH, we believe the future of work will be shaped by
                those who come together to challenge norms, share knowledge, and
                build solutions that matter. From the beginning, our vision has
                been to create a platform where leaders in Commercial Real
                Estate, Facilities, Workplace Strategy, and Emerging
                Technologies can not just discuss change, but drive it.
              </p>
              <p>
                Such platforms are essential for the industry — spaces where
                bright minds come together to deliberate, debate, and develop
                better solutions, while creating greater awareness across the
                ecosystem.
              </p>
              <p>
                Every chapter of the CREDTECH reflects this purpose. From GCC
                growth and AI adoption to workplace design, sustainability, and
                mobility, our conversations are rooted in real impact and
                actionable insight.
              </p>
              <p>
                What began as a forum has evolved into a collaborative movement
                — a community that learns together, innovates together, and
                builds together.
              </p>
              <p>
                As we move toward Vision 2030, our commitment remains clear: to
                connect ideas with execution, leaders with opportunity, and
                today’s challenges with tomorrow’s possibilities.
              </p>
              <p>
                Together, let’s shape workplaces that are innovative,
                sustainable, and truly people-centric.
              </p>
            </div>
            <p className="founder-signature">
              – Sunanda Jaiprakash Founder, CREDTECH- India’s CRE and Workspace
              Intelligence Forum
            </p>
          </div>
        </section>
      </div>

      {/* 3. Uniting Visionaries / Sustainability Banner */}

      <section className="visionary-banner">
        <div
          className="sustainability-box"
          style={{ backgroundImage: `url(${sustainabilityBg})` }}
        >
          <h3 className="visionary-header">
            Uniting Business Visionaries to Explore Key Trends Shaping the
            Future:
          </h3>
          <h2 className="sustainability-title">
            {heroTitles[currentTitleIndex]}
          </h2>
          <div className="sustainability-footer">
            JOIN 100+ DECISION-MAKERS ACROSS INDIA’S TOP CITIES
          </div>
        </div>
      </section>

      {/* 4. About CREDTECH Details */}
      <section className="about-details-section">
        <h2 className="section-header">About CREDTECH</h2>

        <h3 className="detail-title">Our Vision</h3>
        <p className="detail-text">
          A platform for business visionaries to shape the future of workspaces
          — powered by insights across GCC leadership, industry growth, AI,
          design thinking, smart workplaces, wellness, sustainability and
          emerging best practices.
        </p>

        <h3 className="detail-title">Our Presence</h3>
        <p className="detail-text">
          Founded in 2020, CREDTECH has emerged as a premier knowledge-sharing
          and networking platform. CREDTECH serves as a forum for dialogue,
          strategic thinking, and collaboration—bringing together leaders
          shaping business growth, workplace transformation, and innovation.
          Across 15+ editions, each session has convened 100+ senior leaders
          from Commercial Real Estate, Facilities, GCCs, Architecture, Workplace
          Strategy, procurement, and emerging startups to collectively reimagine
          the future of workspaces. Today, the platform spans four key
          cities—Bangalore, Hyderabad, Pune, and Chennai.
        </p>
      </section>
    </div>
  );
};

export default AboutUsPage;
